import api from "@/services/http/api";
import apiAuth from "@/services/http/apiAuth";

/* ============================================================
   PÚBLICAS
   ============================================================ */

/**
 * Lista asociaciones publicadas. Opcionalmente filtrar por región.
 * @param {object} opts - { región?: string }
 */
export async function listarAsociaciones({ región = null } = {}) {
  const params = {};
  if (región) params.región = región;
  const res = await api.get("/asociaciones", { params });
  return res.data; // { items, total }
}

/**
 * Obtiene una asociación por id.
 */
export async function obtenerAsociacion(id) {
  const res = await api.get(`/asociaciones/${id}`);
  return res.data;
}

/* ============================================================
   ADMIN
   ============================================================ */

export async function listarAsociacionesAdmin() {
  const res = await apiAuth.get("/asociaciones/admin/all");
  return {
    ...res.data,
    items: [...(res.data.items || [])].sort((a, b) =>
      String(a.name || "").localeCompare(String(b.name || ""), "es", {
        sensitivity: "base",
      }),
    ),
  }; // { items, total }
}

export async function crearAsociacion(payload) {
  const res = await apiAuth.post("/asociaciones", payload);
  return res.data;
}

export async function editarAsociacion(id, payload) {
  const res = await apiAuth.put(`/asociaciones/${id}`, payload);
  return res.data;
}

export async function eliminarAsociacion(id) {
  const res = await apiAuth.delete(`/asociaciones/${id}`);
  return res.data;
}

export async function subirAsociacionLogo(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiAuth.post(`/asociaciones/${id}/logo`, formData);
  return res.data;
}

export async function subirAsociacionHero(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiAuth.post(`/asociaciones/${id}/hero`, formData);
  return res.data;
}
